import {responses} from "@/utils/responses";
import {Storage} from "@/services/Storage";
import axios from "axios";
import router from "@/router";

export default {
    name: 'stock',
    state: {
        stock: [],
        stockSetting: [],
        stockItem: {},
        stockCache: new Map(),
        limit : 30,
    },
    getters: {
        getStockProducts: (state) => (limit) => {
            let items = state.stock;
            let products = [];
            for (let i = 0; i < items.length; i++){
                let item = products.find(p=>p.PLU===items[i].PLU);
                if (!item){
                    items[i].index = i+1;
                    if (limit){
                        if (items[i].index < limit){
                            products.push(items[i]);
                        }
                    }else{
                        products.push(items[i]);
                    }
                }
            }
            return products;
        },
        getAllStockProducts: ({stockCache}) => [...stockCache.values()],
        getStockItem: (state) => state.stockItem,
        getByPlu: (state) => (plu) => state.stockCache.get(plu),
        getLimit:(state) => state.limit,
        getStockSetting: (state) => state.stockSetting,
    },

    mutations: {
        setLimit:(state,limit) =>state.limit = limit,
        setStock: async (state, payload) => {
            if (payload) {
                payload.sort((a, b) => a.Description.localeCompare(b.Description))
                await Storage.setStock(payload);
                state.stock = payload.filter(x => x.FastLine === 1)
                    .sort((a, b) => {
                        if (a.Description < b.Description) return -1;
                        if (a.Description > b.Description) return 1;
                        // If Descriptions are the same, then sort by PLU
                        if (a.PLU < b.PLU) return -1;
                        if (a.PLU > b.PLU) return 1;
                        return 0;
                    });
                //state.allStock = payload
                state.stockCache = payload.reduce((mapAcc, obj) => {
                    mapAcc.set(obj.PLU, obj);
                    return mapAcc;
                }, new Map())

            } else {
                await Storage.getFastLine().then(res => {
                    state.stock = res.sort((a, b) => {
                        if (a.Description < b.Description) return -1;
                        if (a.Description > b.Description) return 1;
                        // If Descriptions are the same, then sort by PLU
                        if (a.PLU < b.PLU) return -1;
                        if (a.PLU > b.PLU) return 1;
                        return 0;
                    });
                })
            }
        },
        setStockSetting: async (state, payload) => {
            if (payload) {
                state.stockSetting = payload;
            }
        },
        setSearch: (state, payload) => {
            state.stock = payload.sort((a, b) => {
                if (a.Description < b.Description) return -1;
                if (a.Description > b.Description) return 1;
                // If Descriptions are the same, then sort by PLU
                if (a.PLU < b.PLU) return -1;
                if (a.PLU > b.PLU) return 1;
                return 0;
            });
        },
        setStockItem: (state, payload) => {
            state.stockItem = payload
        },
        addStockItem: (state, payload) => {
            Storage.getAllStock().then(stock => {
                state.stock = state.stock.map(s => {
                    if (s.PLU === payload.PLU) {
                        return payload;
                    }
                    return s;
                })
                return Storage.setStock(state.stock);
            });
        }
    },
    actions: {
        addStockItem: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            try {
                delete payload.CreatedUser
            } catch (e) {
                console.error(e)
            }
            return axios.post(`${serverApi}stock/${store.StoreDB}`, payload)
                .then(({data}) => {
                    context.commit('addStockItem', data);
                    context.commit('setStockItem', data);
                    return data;
                })
                .catch((err) => errorHandler.tomcatError(err)).finally(() => context.dispatch('getAllStock'))
        },
        getStockSetting: (context, plu) => {
            return Storage.getStockSetting(plu)
        },
        getAllStock: async (context) => {
            let store = await Storage.getDefaultStore();
            let device = await Storage.getDeviceSettings();
            let user = await Storage.getCurrentUser();
            if (!store) return;
            // return axios.get(`https://realtime.pos.co.zm:8443/OnlineSalesServer/stock/${store.StoreDB}`,  {params: {pc: device.PC,user : user?user.Username:undefined}})
            return axios.get(serverApi + `stock/${store.StoreDB}`, {params: {pc: device.PC,user : user?user.Username:undefined}})
                .then(async ({data}) => {
                    const stockSettings = data.map(s => {
                        let set = s.StockSetting
                        if (set) {
                            return {
                                plu: s.PLU,
                                cookingLink: set.CookingLink,
                                mtv: set.mtv,
                                askForPrice: set.askForPrice,
                                askForDescription: set.askForDescription,
                                askForBoth: set.askForBoth,
                                NonStock: set.NonStock,
                                tourism: set.tourism,
                                getQtyFromPrice: set.getQtyFromPrice,
                            }
                        } else {
                            return {
                                plu: s.PLU,
                                mtv: 0.00,
                                tourism: false,
                                NonStock: false,
                                cookingLink: false,
                                askForPrice: false,
                                askForDescription: false,
                                askForBoth: false,
                            }
                        }
                    })
                    const stock = data.map(s => {
                        delete s.CreatedDate
                        delete s.Image
                        delete s.Price1
                        delete s.Price2
                        delete s.Price3
                        delete s.Price4
                        delete s.Price5
                        delete s.args
                        delete s.where_between
                        return s;
                    })
                    await context.commit('setStock', stock);
                    await context.commit('setStockSetting', stockSettings);
                    context.dispatch(`setStockImages`,stock)
                }).catch((err) => errorHandler.tomcatError(err))
        },
        searchStock: (context, query) => {
            let search = context.getters.getSearchCategories;
            query.category = search.category;
            query.subCategory = search.subCategory;
            query.sub2Category = search.sub2Category;

            context.commit('setCurrentCategory', query.category)
            context.commit('setSubCategory', query.subCategory)
            context.commit('setSubCategory2', query.sub2Category)
            return Storage.searchStock(query).then(res => {
                context.commit('setSearch', res)
            }).catch(err => console.error(err))
        },
        searchDescription: (context, query) => {
            let search = context.getters.getSearchCategories;
            query.category = search.category;
            query.subCategory = search.subCategory;
            query.sub2Category = search.sub2Category;

            context.commit('setCurrentCategory', query.category)
            context.commit('setSubCategory', query.subCategory)
            context.commit('setSubCategory2', query.sub2Category)
            return Storage.searchStockDesc(query).then(res => {
                context.commit('setSearch', res)
            }).catch(err => console.error(err))
        },

        searchDepartment: async (context, query) => {
            let search = context.getters.getSearchCategories;
            query.category = search.category;
            query.subCategory = search.subCategory;
            query.sub2Category = search.sub2Category;

            query.description = '';
            return Storage.searchStockDesc(query).then((value => value));
        },

        getFastLine: (context, query) => {
            context.commit(`setSearchCategories`, {
                category: ``,
                subCategory: ``,
                sub2Category: ``
            })
            return Storage.getFastLine().then(res => {
                context.commit('setSearch', res)
            }).catch(err => console.error(err))
        },

        setStockImages: async (context,stockItems) => {
            let store = await Storage.getDefaultStore();
            let images = [];
            let methods = stockItems.filter(stock=>stock.hasImage).map(item => {
                return axios.get(franchiseSpringApi + `stockImage/${store.StoreDB}/getImage?PLU=` + item.PLU).then(({data}) => {
                    if (data) images.push({PLU: item.PLU, Image: data});
                });
            });
            return Promise.all(methods).then(async () => {
                await Storage.setStockImages(images);
                context.commit(`setStock`)
            })
        },
    }
}
